import { HideZeroValuesPipe } from './../common/hide-zero-values.pipe'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'

import { TranslateModule } from '@ngx-translate/core'

import { LatitudeAltModule } from '../latitude/latitude.module'
import { CommonCompModule } from '../common/common.module'
import { WidgetModule } from '../widget/widget.module'

import { MobilityRoutingModule } from './mobility.routing.module'
import { MobilityComponent } from './mobility/mobility.component'
import { MobilityWidgetsComponent } from './mobility/mobility-widgets/mobility-widgets.component'
import { MobilityLegendWidgetComponent } from './mobility/legend-widget/legend-widget.component'
import { RetailComponent } from './retail/retail.component'
import { MapControlsComponent } from './mobility/map-controls/map-controls.component'
import { MapLoadingComponent } from './mobility/map-loading/map-loading.component'
import { OohComponent } from 'app/mobility/ooh/ooh.component'
import { CampaignsComponent } from 'app/mobility/campaigns/campaigns.component'

const components = [
  MobilityComponent,
  MobilityWidgetsComponent,
  MobilityLegendWidgetComponent,
  RetailComponent,
  OohComponent,
  CampaignsComponent,
  MapControlsComponent,
  MapLoadingComponent,
]

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    LatitudeAltModule,
    CommonCompModule,
    WidgetModule,
    TranslateModule,
    MobilityRoutingModule,
  ],
  declarations: [...components],
  exports: [...components],
  providers: [HideZeroValuesPipe],
})
export class MobilityModule {}
